export const normalizePath = (path: string): string => {
  if (path === '') return ''

  return path.toLowerCase().replaceAll(/\/\d+/g, '/*').replace(/\/$/, '') || '/'
}
